import {http} from '../config';
export default{


    //Ajustar para recibir parametro
    listarProductoVendedorPublico:(vendedor,categoria)=>{
        return http.get('api/vendedores/publico/'+vendedor+'/'+categoria);
    },


    listarVendedores:()=>{
        return http.get('api/vendedores/lista/publico');
    },

     listarVendedoresAdmin:()=>{
        return http.get('api/vendedores/');
    },
    save:(vendedor)=>{
        return http.post('api/vendedores',vendedor)
    },
   update: (vendedor) => {
  return http.put('api/vendedores/' + vendedor.id, vendedor)
},
    delete:(vendedor)=>{
        return http.delete('api/vendedores/'+vendedor.id)
    }


}